export default __webpack_public_path__ + "static/media/handshake.0e8c2bd2.png";